<template>
	<div>
		<el-row justify="center" type="flex">
			<el-col :span="10" class="sortcol" v-show="!success">
				<draggable v-model="steps">
					<div v-for="(item, index) in steps" :key="index" class="sortitem" :style="color[index]">
						<div class="sorttext">{{ item }}</div>
					</div>
				</draggable>
			</el-col>
			<el-col :span="4" v-show="!success">
				<div class="tips">
					<div>拖动进行排序，点击确定提交排序过程</div>
					<el-button type="primary" @click="judge">确定</el-button>
				</div>
			</el-col>

			<el-col :span="10" v-show="curstep === 4">
				<el-form label-width="120px">
					<el-form-item label="滤波器类型选择">
						<el-select v-model="filter">
							<el-option label="低通滤波器" :value="0"></el-option>
							<el-option label="高通滤波器" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="截止频率选择">
						<el-select v-model="frequency" @change="filter_count[filter] += 1">
							<el-option v-for="(feq, index) in feqs" :key="index" :label="feq" :value="feq"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<el-row>请选择滤波器及参数，并对比体会不同的滤波器类型和截止频率下的效果！</el-row>
			</el-col>
			<el-col :span="10" v-show="curstep == 7">
				<h1 v-if="filter === 1 && frequency >= 5" style="color: red;">
					高通滤波器截止频率搭配不合理，不能获得图像足够细节，无法判断呼吸器状态！建议根据中心化频谱中的图像频谱分布特点，重新选择滤波器截止频率！
				</h1>
				<h1 v-else-if="filter === 0 && frequency <= 50" style="color: red;">
					低滤波器截止频率搭配不合理，不能获得图像足够细节，无法判断呼吸器状态！建议根据中心化频谱中的图像频谱分布特点，重新选择滤波器截止频率！
				</h1>
				<h1 v-else>
					呼吸器状态识别成功！主变呼吸器红色区域占比较高，请联系停运主变并更换呼吸器!
				</h1>
			</el-col>
			<el-col :span="10">
				<el-row type="flex" justify="center">
					<img :src="imgs" height="400px" />
					<img :src="freq1" height="400px" v-if="curstep === 2" />
					<img :src="freq2" height="400px" v-if="curstep === 3" />
				</el-row>
			</el-col>
		</el-row>
		<el-row style="margin-top: 20px;">
			<!-- <el-col :span="24"> -->
			<el-steps :active="curstep" finish-status="success" align-center>
				<el-step title="原始图像"></el-step>
				<el-step v-for="(item, index) in steps" :title="item" :key="index"></el-step>
			</el-steps>
			<!-- </el-col> -->
		</el-row>
		<el-row justify="center" type="flex" v-show="success" style="margin-top: 20px;">
			<el-col :span="4">
				<el-button @click="curstep - 1 < 0 ? 0 : curstep--">上一步</el-button>
			</el-col>
			<el-col :span="4">
				<el-button v-if="curstep < 7" type="primary" @click="next()">下一步</el-button>
				<el-button v-else type="primary" @click="submit">提交</el-button>
			</el-col>
		</el-row>
	</div>
</template>
<script>
import draggable from 'vuedraggable'
import origin from '../assets/huxiqi/origin.png'
import huxiq from '../assets/huxiqi/huxiq.jpg'
import fourier from '../assets/huxiqi/fourier.png'
import center from '../assets/huxiqi/center.png'
import freq1 from '../assets/huxiqi/freq1.png'
import freq2 from '../assets/huxiqi/freq2.png'
import low1 from '../assets/huxiqi/低通1.png'
import low3 from '../assets/huxiqi/低通3.png'
import low5 from '../assets/huxiqi/低通5.png'
import low10 from '../assets/huxiqi/低通10.png'
import low25 from '../assets/huxiqi/低通25.png'
import low50 from '../assets/huxiqi/低通50.png'
import low75 from '../assets/huxiqi/低通75.png'
import low100 from '../assets/huxiqi/低通100.png'
import low1000 from '../assets/huxiqi/低通1000.png'
import high1 from '../assets/huxiqi/高通1.png'
import high3 from '../assets/huxiqi/高通3.png'
import high5 from '../assets/huxiqi/高通5.png'
import high10 from '../assets/huxiqi/高通10.png'
import high25 from '../assets/huxiqi/高通25.png'
import high50 from '../assets/huxiqi/高通50.png'
import high75 from '../assets/huxiqi/高通75.png'
import high100 from '../assets/huxiqi/高通100.png'
import high1000 from '../assets/huxiqi/高通1000.png'
import low1r from '../assets/huxiqi/低通锐化1.png'
import low3r from '../assets/huxiqi/低通锐化3.png'
import low5r from '../assets/huxiqi/低通锐化5.png'
import low10r from '../assets/huxiqi/低通锐化10.png'
import low25r from '../assets/huxiqi/低通锐化25.png'
import low50r from '../assets/huxiqi/低通锐化50.png'
import low75r from '../assets/huxiqi/低通锐化75.png'
import low100r from '../assets/huxiqi/低通锐化100.png'
import low1000r from '../assets/huxiqi/低通锐化1000.png'
import high1r from '../assets/huxiqi/高通锐化1.png'
import high3r from '../assets/huxiqi/高通锐化3.png'
import high5r from '../assets/huxiqi/高通锐化5.png'
import high10r from '../assets/huxiqi/高通锐化10.png'
import high25r from '../assets/huxiqi/高通锐化25.png'
import high50r from '../assets/huxiqi/高通锐化50.png'
import high75r from '../assets/huxiqi/高通锐化75.png'
import high100r from '../assets/huxiqi/高通锐化100.png'
import high1000r from '../assets/huxiqi/高通锐化1000.png'
import imgfftL1 from '../assets/huxiqi/imgfftL1.png'
import imgfftL3 from '../assets/huxiqi/imgfftL3.png'
import imgfftL5 from '../assets/huxiqi/imgfftL5.png'
import imgfftL10 from '../assets/huxiqi/imgfftL10.png'
import imgfftL25 from '../assets/huxiqi/imgfftL25.png'
import imgfftL50 from '../assets/huxiqi/imgfftL50.png'
import imgfftL75 from '../assets/huxiqi/imgfftL75.png'
import imgfftL100 from '../assets/huxiqi/imgfftL100.png'
import imgfftL1000 from '../assets/huxiqi/imgfftL1000.png'
import imgfftR1 from '../assets/huxiqi/imgfftR1.png'
import imgfftR3 from '../assets/huxiqi/imgfftR3.png'
import imgfftR5 from '../assets/huxiqi/imgfftR5.png'
import imgfftR10 from '../assets/huxiqi/imgfftR10.png'
import imgfftR25 from '../assets/huxiqi/imgfftR25.png'
import imgfftR50 from '../assets/huxiqi/imgfftR50.png'
import imgfftR75 from '../assets/huxiqi/imgfftR75.png'
import imgfftR100 from '../assets/huxiqi/imgfftR100.png'
import imgfftR1000 from '../assets/huxiqi/imgfftR1000.png'

export default {
	components: {
		draggable
	},
	data() {
		return {
			active: 1,
			curstep: 0,
			steps: ["截取对象", "快速傅里叶变换", "中心化频谱", "滤波器选择", "傅里叶反变换", "拉普拉斯锐化", "颜色统计像素"],
			ans: ["截取对象", "快速傅里叶变换", "中心化频谱", "滤波器选择", "傅里叶反变换", "拉普拉斯锐化", "颜色统计像素"],
			color: [
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
				{ backgroundColor: '#ffffff' },
			],
			success: false,
			failed: false,
			filter: 0,
			frequency: 1,
			feqs: [1000, 100, 75, 50, 25, 10, 5, 3, 1],
			freq1, freq2,
			filterL: {
				1: low1,
				3: low3,
				5: low5,
				10: low10,
				25: low25,
				50: low50,
				75: low75,
				100: low100,
				1000: low1000
			},
			filterH: {
				1: high1,
				3: high3,
				5: high5,
				10: high10,
				25: high25,
				50: high50,
				75: high75,
				100: high100,
				1000: high1000
			},
			sharpL: {
				1: low1r,
				3: low3r,
				5: low5r,
				10: low10r,
				25: low25r,
				50: low50r,
				75: low75r,
				100: low100r,
				1000: low1000r
			},
			sharpH: {
				1: high1r,
				3: high3r,
				5: high5r,
				10: high10r,
				25: high25r,
				50: high50r,
				75: high75r,
				100: high100r,
				1000: high1000r
			},
			fftL: {
				1: imgfftL1,
				3: imgfftL3,
				5: imgfftL5,
				10: imgfftL10,
				25: imgfftL25,
				50: imgfftL50,
				75: imgfftL75,
				100: imgfftL100,
				1000: imgfftL1000
			},
			fftR: {
				1: imgfftR1,
				3: imgfftR3,
				5: imgfftR5,
				10: imgfftR10,
				25: imgfftR25,
				50: imgfftR50,
				75: imgfftR75,
				100: imgfftR100,
				1000: imgfftR1000
			},
			count: 0,
			score: [0, 0, 0, 0, 0],
			filter_count: [0, 0],
			first: true
		}
	},
	computed: {
		imgs: function () {
			if (this.curstep == 0) {
				return origin
			} else if (this.curstep == 1) {
				return huxiq
			} else if (this.curstep == 2) {
				return fourier
			} else if (this.curstep == 3) {
				return center
			} else if (this.curstep == 4) {
				if (this.filter === 0)
					return this.fftL[this.frequency]
				else
					return this.fftR[this.frequency]
			} else if (this.curstep == 5) {
				if (this.filter == 0) {
					return this.filterL[this.frequency]
				} else {
					return this.filterH[this.frequency]
				}
			} else if (this.curstep == 6 || this.curstep == 7) {
				if (this.filter == 0) {
					return this.sharpL[this.frequency]
				} else {
					return this.sharpH[this.frequency]
				}
			}
			return "../assets/huxiq.jpg"
		}
	},
	methods: {
		judge() {
			if (this.steps.join('') === this.ans.join('')) {
				this.$message.success('排序成功！')
				this.success = true
				if (this.count === 0) this.score[0] = 10;
				else if (this.count === 1) this.score[0] = 8;
				else if (this.count === 2) this.score[0] = 6;
				else if (this.count === 3) this.score[0] = 1;
			} else {
				this.count += 1;
				if (this.count === 3) {
					this.$message.error('尝试机会已用完，请阅读答案并进行下一步。')
					this.success = true
					this.steps = this.ans
					this.score[0] = 1;
					return
				}
				this.$message.error(`排序错误！还有${3 - this.count}次尝试机会。`)
				for (let i in this.steps) {
					if (this.steps[i] !== this.ans[i]) {
						this.color[i].backgroundColor = '#EE0000'
						setTimeout(() => {
							this.color[i].backgroundColor = '#ffffff'
						}, 1000);
					}
				}
			}
		},
		submit() {
			if (this.filter === 0) {
				if (this.frequency <= 50) this.score[4] = 0;
				else if (this.frequency === 75) this.score[4] = 2;
				else if (this.frequency === 100) this.score[4] = 4;
				else if (this.frequency === 1000) this.score[4] = 5;
			} else {
				if (this.frequency >= 5) this.score[4] = 0;
				else if (this.frequency === 3) this.score[4] = 3;
				else if (this.frequency === 1) this.score[4] = 5;
			}
			this.$store.commit("SetScore1", { score: this.score[0] + this.score[1] + this.score[2] + this.score[3] + this.score[4] })
			this.$store.commit("SetSteps1", this.steps.join('-'))
			this.$message.success('提交成功！')

		},
		next() {
			if (this.curstep === 4 && this.first) {
				this.first = false;
				if (this.filter_count[0] === 0) this.score[1] = 1;
				else if (this.filter_count[0] === 1) this.score[1] = 3;
				else if (this.filter_count[0] >= 2) this.score[1] = 5;
				if (this.filter_count[1] === 0) this.score[2] = 1;
				else if (this.filter_count[1] === 1) this.score[2] = 3;
				else if (this.filter_count[1] >= 2) this.score[2] = 5;
				if (this.filter === 0) {
					if (this.frequency <= 50) this.score[3] = 0;
					else if (this.frequency === 75) this.score[3] = 4;
					else if (this.frequency === 100) this.score[3] = 8;
					else if (this.frequency === 1000) this.score[3] = 10;
				} else {
					if (this.frequency >= 5) this.score[3] = 0;
					else if (this.frequency === 3) this.score[3] = 6;
					else if (this.frequency === 1) this.score[3] = 10;
				}
			}
			this.curstep++;
		}
	},
	mounted() {
		this.steps = this._.shuffle(this.steps)
	}
}
</script>
<style>
.rect {
	border: 1px solid;
	width: 100px;
	height: 50px;
	/* margin: 0 20px; */
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
}
.diamond {
	width: 100px;
	height: 50px;
	/* border: 1px solid; */
	/* transform: skew(60deg); */
	/* transform: rotate(45deg); */
}
/* .diamond1:after {
  content: '';
  position: absolute;
  left: -50px; top: 70px;
  border: 50px solid transparent;
  border-top: 70px solid red;
} */

#canvas1 {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 380px;
	/* margin-top: 10px; */
	align-items: center;
}
#part1 {
	height: 330px;
	width: 100%;
	display: flex;
	flex-direction: row;
	/* align-items: flex-center; */
	justify-content: center;
}
#part2 {
	display: flex;
	/* width: 400px; */
	/* height: 300px; */
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-end;
}
.sortitem {
	width: 200px;
	height: 50px;
	display: flex;
	margin: 5px auto;
	flex-direction: column;
	justify-content: center;
	/* background-color: aquamarine; */
	border-radius: 5px;
	border: 1px solid;
}

.sortcol {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	/* align-items: space-between; */
	height: 400px;
}
.tips {
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	height: 400px;
}
</style>
